<template>
  <div class="sharebtn">
    <a-button icon="unordered-list" style="margin-right: 20px;" @click="visible=true;init()">反馈列表</a-button>
    <drag-modal  title="反馈列表" width="784px" :visible="visible" @cancel="page=1;visible=false;">
      <div class="table">
        <table>
          <thead>
            <td width="35%">反馈用户</td>
            <td width="35%">反馈人</td>
            <td width="30%">反馈日期</td>
          </thead>
          <tbody>
            <tr v-for="i in list">
              <td>{{ i.target_user?i.target_user.uname:'/'}}</td>  
              <td>{{ i.user?i.user.uname:'/'}}</td>  
              <td>{{ i.create_time }}</td>  
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pages" v-if="count>10">
        <a-pagination v-model="page" show-quick-jumper :total="count" show-less-items :pageSize='10' @change='init' />
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { shareHis } from '@/server/debtor'
export default{
  data(){
    return {
      list:[],
      visible:false,
      page:1,
      count:0
    }
  },
  created(){
   

  },
  methods:{

    init(){
      shareHis({cause_id:this.$store.state.cause.id,limit:10,page:this.page}).then(e=>{
        this.list=e.list
        this.count=e.count
      })
    }
  }
}
</script>